import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function TooltipRow({color, children}) {
  const className = classnames('tooltip-row', {[`is-color-${color}`]: color})

  return <div className={className}>{children}</div>
}

TooltipRow.propTypes = {
  color: PropTypes.oneOf(['white'])
}



// WEBPACK FOOTER //
// ./client/components/Tooltip/TooltipRow.js